import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    HorizontalFlex,
    InfoAlert,
    ModalFooter,
    ButtonSecondary,
    ErrorAlert,
} from 'smartsuite-ui';
import ConfirmModal from './ConfirmModal';
import { useLabelContext } from '../../shared/hooks/labelContext';
import SavedDashboardItem from './SavedDashboardItem';

export default function ManageSavedDashboardsModal(props) {
    const { dashboardLabels, translationLabels } = useLabelContext();

    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
    const [dashboardToRemove, setDashboardToRemove] = useState({
        name: '',
        key: '',
    });

    function onDelete() {
        setIsConfirmModalVisible(false);
        props.deleteSavedDashboard(dashboardToRemove.key);
    }

    function renderModalBody(savedDashboardNames) {
        const savedDashboardsThatCanBeDeleted = savedDashboardNames.filter(
            (savedName) => savedName.key && savedName.key !== 'Default'
        );

        return savedDashboardsThatCanBeDeleted.length ? (
            savedDashboardsThatCanBeDeleted.map((savedDashboard) => (
                <SavedDashboardItem
                    key={savedDashboard.key}
                    pageTitle={props.pageTitle}
                    savedDashboard={savedDashboard}
                    setDashboardToRemove={setDashboardToRemove}
                    setIsConfirmModalVisible={setIsConfirmModalVisible}
                    siteMapKey={props.siteMapKey}
                    viewKey={props.viewKey}
                />
            ))
        ) : (
            <InfoAlert>{dashboardLabels.noSavedFiltersFound}</InfoAlert>
        );
    }

    /* eslint-disable react/jsx-one-expression-per-line */
    if (isConfirmModalVisible) {
        return (
            <ConfirmModal
                confirmTitle={translationLabels.confirm}
                confirmLabel={translationLabels.yes}
                dismissLabel={translationLabels.no}
                onConfirm={onDelete}
                onDismiss={() => setIsConfirmModalVisible(false)}
            >
                <Label>
                    {`${dashboardLabels.areYouSureYouWantTo} ${translationLabels.delete} `}
                    <strong>{`"${dashboardToRemove.name}"`}</strong>?
                    {` ${dashboardLabels.changeEffectsLandingPage}`}
                </Label>
            </ConfirmModal>
        );
    }
    /* eslint-enable react/jsx-one-expression-per-line */

    return (
        <Modal onOverlayClick={props.onDismiss}>
            <ModalHeader onDismiss={props.onDismiss}>
                {dashboardLabels.manageSavedFilters}
            </ModalHeader>
            <ModalBody>
                {props.savedDashboardError && (
                    <ErrorAlert>{props.savedDashboardError}</ErrorAlert>
                )}
                {renderModalBody(props.savedDashboardNames)}
            </ModalBody>
            <ModalFooter>
                <HorizontalFlex cssClassModifiers={['justify-flex-end']}>
                    <ButtonSecondary onClick={props.onDismiss}>
                        {translationLabels.close}
                    </ButtonSecondary>
                </HorizontalFlex>
            </ModalFooter>
        </Modal>
    );
}

ManageSavedDashboardsModal.propTypes = {
    deleteSavedDashboard: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    pageTitle: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    savedDashboardError: PropTypes.string,
    savedDashboardNames: PropTypes.instanceOf(Array).isRequired,
    siteMapKey: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    viewKey: PropTypes.string.isRequired,
};

ManageSavedDashboardsModal.defaultProps = {
    savedDashboardError: null,
    siteMapKey: undefined,
};
